import useTrackPreviousPathname from "./useTrackPreviousPathname";
import useSetApiKey from "./useSetApiKey";
import useCurrentUserWebsocket from "./useCurrentUserWebsocket";
import useReferralCode from "./useReferralCode";

export function TopLevelHooks() {
  useSetApiKey();
  useCurrentUserWebsocket();
  useTrackPreviousPathname();
  useReferralCode();
  return <></>;
}
